var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.5 9.518A4.522 4.522 0 0011 14.06v.007c0 3.412 4.5 8.45 4.5 8.45s4.5-5.038 4.5-8.45a4.522 4.522 0 00-4.494-4.55zm0 6.175a1.625 1.625 0 111.607-1.643v.018a1.617 1.617 0 01-1.607 1.625z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.622 5.453L23.12 2.079a.7.7 0 00-.488-.059L9 5.235a.7.7 0 01-.467-.048L3.001 2.343A.699.699 0 002 2.975v23.087a.7.7 0 00.386.625l6.091 3.274a.7.7 0 00.49.052l13.115-3.363a.7.7 0 01.49.052l6.414 3.066A.699.699 0 0030 29.142V6.074a.7.7 0 00-.378-.621zM8 28.569l-5-2.687V3.467l5 2.57zm1 .403V6.235a1.706 1.706 0 00.23-.027L22 3.196V25.66c-.055.009-.113.007-.166.021zm20-.306l-5.98-2.858L23 25.8V3.143l6 3.113z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--map-outline-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'MapOutlineIcon';
export default Icon;